import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectDraftBoardForm } from "../../components/Settings/redux/selector";
import { GroupByTypeEnum } from "../../types";
import { ticketGroupsActions } from "./redux/slice";
import { ITicketFormData } from "./types";

const GROUP_FIELD_MAP: Partial<Record<GroupByTypeEnum, keyof ITicketFormData>> =
  {
    [GroupByTypeEnum.STATUS]: "status",
    [GroupByTypeEnum.ASSIGNEE]: "assignedTo",
    [GroupByTypeEnum.TICKET_TYPE]: "type",
    [GroupByTypeEnum.DUE_DATE]: "dueDate",
    [GroupByTypeEnum.TAGS]: "tags",
    [GroupByTypeEnum.PRIORITY]: "priority",
    [GroupByTypeEnum.SPRINT]: "sprint",
    [GroupByTypeEnum.RELEASE]: "release",
    [GroupByTypeEnum.EPIC]: "epic",
    [GroupByTypeEnum.EFFORTS_ESTIMATION]: "effortEstimated",
    [GroupByTypeEnum.EFFORT_ACTUAL]: "effortActual",
  };

export const useTicketCreateActions = () => {
  const { groupBy, subGroupBy } = useSelector(selectDraftBoardForm);
  const dispatch = useDispatch();

  const setTicketField = useCallback(
    (
      name: keyof ITicketFormData,
      value: string | string[] | number | undefined,
    ) => {
      if (name === "tags") {
        dispatch(
          ticketGroupsActions.setTicketTagsFormValue({
            ids: value as string,
          }),
        );
      } else {
        dispatch(
          ticketGroupsActions.setTicketFormValue({
            name,
            value,
          }),
        );
      }
    },
    [dispatch],
  );

  const applyGroupValueToBoardForm = useCallback(
    (groupId: string, subGroupId?: string) => {
      if (groupId) {
        const fieldName = GROUP_FIELD_MAP[groupBy];
        if (fieldName) {
          dispatch(
            ticketGroupsActions.setTicketFormValue({
              name: fieldName,
              value: groupId,
            }),
          );
        }
      }

      if (subGroupId && subGroupBy) {
        const subFieldName = GROUP_FIELD_MAP[subGroupBy];
        if (subFieldName) {
          dispatch(
            ticketGroupsActions.setTicketFormValue({
              name: subFieldName,
              value: subGroupId,
            }),
          );
        }
      }
    },
    [dispatch, groupBy, subGroupBy],
  );

  return { applyGroupValueToBoardForm, setTicketField };
};
